// extracted by mini-css-extract-plugin
export default {"seasons":"Seasons_seasons__RNEh1","error":"Seasons_error__FP0SN"};